var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.886,
    height: 27,
    viewBox: "0 0 64.886 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stripe_wordmark_-_blurple",
    "data-name": "Stripe wordmark - blurple",
    transform: "translate(-54 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15126",
    "data-name": "Path 15126",
    d: "M353.092,75.855c0-4.614-2.235-8.255-6.507-8.255-4.29,0-6.885,3.641-6.885,8.219,0,5.425,3.064,8.165,7.462,8.165a10.05,10.05,0,0,0,4.993-1.172v-3.6a9.571,9.571,0,0,1-4.416.991c-1.748,0-3.3-.613-3.5-2.74h8.814C353.056,77.225,353.092,76.288,353.092,75.855Zm-8.9-1.712c0-2.037,1.244-2.884,2.379-2.884,1.1,0,2.271.847,2.271,2.884Z",
    transform: "translate(-234.205 -25.904)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15127",
    "data-name": "Path 15127",
    d: "M265.932,67.6a5.092,5.092,0,0,0-3.533,1.406l-.234-1.117H258.2V88.9l4.506-.955.018-5.1a5.076,5.076,0,0,0,3.19,1.136c3.226,0,6.164-2.6,6.164-8.309C272.06,70.448,269.087,67.6,265.932,67.6Zm-1.081,12.419a2.694,2.694,0,0,1-2.127-.847l-.018-6.687a2.683,2.683,0,0,1,2.145-.883c1.64,0,2.776,1.838,2.776,4.2C267.627,78.216,266.509,80.019,264.851,80.019Z",
    transform: "translate(-167.395 -25.904)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15128",
    "data-name": "Path 15128",
    d: "M223.8,40.632l4.524-.973V36l-4.524.955Z",
    transform: "translate(-139.195 0)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1767",
    "data-name": "Rectangle 1767",
    width: 4.524,
    height: 15.771,
    transform: "translate(84.605 42.002)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15129",
    "data-name": "Path 15129",
    d: "M177.882,69.786l-.288-1.334H173.7V84.224h4.506V73.535a3.179,3.179,0,0,1,3.425-.937V68.453A3.059,3.059,0,0,0,177.882,69.786Z",
    transform: "translate(-98.125 -26.451)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15130",
    "data-name": "Path 15130",
    d: "M126.816,47.6l-4.4.937L122.4,62.974a4.529,4.529,0,0,0,4.668,4.632,6.962,6.962,0,0,0,3.154-.595V63.353c-.577.234-3.425,1.063-3.425-1.6v-6.4h3.425V51.511H126.8Z",
    transform: "translate(-56.072 -9.509)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15131",
    "data-name": "Path 15131",
    d: "M58.56,72.485c0-.7.577-.973,1.532-.973a10.053,10.053,0,0,1,4.47,1.154V68.429a11.886,11.886,0,0,0-4.47-.829C56.433,67.6,54,69.511,54,72.7c0,4.975,6.849,4.182,6.849,6.326,0,.829-.721,1.1-1.73,1.1A11.219,11.219,0,0,1,54.2,78.685v4.29A12.5,12.5,0,0,0,59.119,84c3.749,0,6.326-1.856,6.326-5.083C65.427,73.548,58.56,74.5,58.56,72.485Z",
    transform: "translate(0 -25.904)",
    fill: "#635bff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.6092a607.svg";
export { ForwardRef as ReactComponent };